import React, { useContext } from "react";
// TypeScript gymnastics so we don't need to make rootStore above "rootStore?"
export const RootStoreContext = React.createContext({
    rootStore: undefined,
});
export function useRootStore() {
    return useContext(RootStoreContext).rootStore;
}
//# sourceMappingURL=RootStoreContext.js.map